import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // Import the App component
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement); // Create the root using createRoot

root.render(
  <React.StrictMode>
    <BrowserRouter>  {/* Wrap the App component with BrowserRouter */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
